import { Circle, Svg } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const HistoryCircle = withDefaultIconProps({ height: 6, width: 6 }, ({ color = '#999999', ...rest }) => (
  <Svg {...rest} viewBox="0 0 6 6">
    <Circle cx="3" cy="3" fill={color} id="Ellipse 50" r="3" />
  </Svg>
));
